import axios from 'axios';
import store from './state/store';


// Estabelecendo a urlBase
let apiHost = store.state.apiUrl;

const axiosConfigs = async (hashToken) => {
  // Obtém o token
  const token = hashToken;
  // Registra a baseURL
  axios.defaults.baseURL = apiHost;
  // Registra um timeout
  axios.defaults.timeout = 350000;

  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  // Configura o header Content-type de todos os métodos HTTP
  axios.defaults.headers.post['Content-Type'] = 'application/json';
  axios.defaults.headers.get['Content-Type'] = 'application/json';
  axios.defaults.headers.delete['Content-Type'] = 'application/json';
  axios.defaults.headers.put['Content-Type'] = 'application/json';
};

axios.interceptors.response.use(
  function (response) {
    let url = response.config.url.split('/');

    if (
      response.headers?.['refreshed-token'] &&
      url[url.length - 1] != 'logout'
    ) {
      // Decodifica o novo token do header da resposta
      const newToken = response.headers?.['refreshed-token'];
      const decodedNewToken = JSON.parse(atob(newToken.split('.')[1]));
      const newExp = decodedNewToken.exp;

      // Pega o token antigo do localStorage
      const oldToken = localStorage.getItem('token');
      let oldExp = 0; 
    
      if (oldToken) {
        try {
          const decodedOldToken = JSON.parse(atob(oldToken.split('.')[1]));
          oldExp = decodedOldToken.exp;
        } catch (error) {
          console.error("Erro ao decodificar o token antigo:", error);
    
        }
      }

      if (newExp > oldExp) {
        const timeInactive = new Date(newExp * 1000);

        store.dispatch('setTimeInactive', timeInactive);
        localStorage.setItem('token', newToken);

        delete axios.defaults.headers.common['Authorization'];
        axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      }
    }
    return response;
  },
  function (error) {
    if (error.response?.data?.message === 'Credenciais inválidas') {
      store.dispatch('setTimeInactive', new Date());
      return;
    }
    return Promise.reject(error);
  }
);

export default axiosConfigs;